import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetHealthProviderFeaturesDocument,
  GetHealthProviderFeaturesQueryVariables,
  HealthProviderFeatureItemDataFragment,
} from '../../types/api/graphql';

export function useHealthProviderFeatureItems(
  variables: GetHealthProviderFeaturesQueryVariables,
  skip?: boolean
) {
  const {
    data: healthProviderFeatureItemsData,
    loading: healthProviderFeatureItemsLoading,
  } = useCacheQuery(GetHealthProviderFeaturesDocument, {
    variables: {
      ...variables,
    },
    skip: skip === true,
  });

  const data = useMemo(
    () =>
      healthProviderFeatureItemsData?.features as HealthProviderFeatureItemDataFragment[],
    [healthProviderFeatureItemsData]
  );

  return {
    data,
    loading: healthProviderFeatureItemsLoading,
  };
}
